import { render, staticRenderFns } from "./LoginKiitos.vue?vue&type=template&id=444312ee&scoped=true"
import script from "./LoginKiitos.vue?vue&type=script&lang=js"
export * from "./LoginKiitos.vue?vue&type=script&lang=js"
import style0 from "./LoginKiitos.vue?vue&type=style&index=0&id=444312ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444312ee",
  null
  
)

export default component.exports